module.exports = __webpack_public_path__ + "static/media/box-gray.86026b6e.svg";